/**
 * Whether an `actionUrl` stays inside this app. Every producer writes a
 * relative path (`/records?id=…`, `/billing`, the budget settings URL), so the
 * check is: resolved against our own origin it keeps that origin. That rejects
 * an absolute URL to another host, a protocol-relative `//host` (and `/\host`,
 * which the URL parser reads the same way), and `javascript:`/`data:` (their
 * origin is opaque) — `window.location.href = actionUrl` would otherwise send
 * the user off-site on a click.
 */
export function isSameOriginUrl(url: string): boolean {
  try {
    return new URL(url, window.location.origin).origin === window.location.origin;
  } catch {
    return false;
  }
}
